module.exports = __webpack_public_path__ + "img/peter-carr-talks-about-risk-lattes-global-quiz-competition.52b406fc.jpg";